import Vue from 'vue'
import Antd from 'ant-design-vue'
import VueDragDrop from 'vue-drag-drop'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css'

Vue.use(Antd)
Vue.use(VueDragDrop)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js